import React, {useState} from 'react'
import {p1, p2} from "../plan/planitems/pl_commons";
import {useDrop} from "react-dnd";
import {FiDownloadCloud} from "react-icons/fi";

const LcDetail = ({lc, showcv, setshowcv}) => {

    const [{canDrop, isOver}, drop] = useDrop(() => ({
        accept: 'lc',
        drop: () => ({
            name: lc.id,
            id: lc.id,
            type: 'lc',
        }),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop()
        })
    }))

    let kmh_raw = parseInt(lc.v) > 0 ? lc.bmspeed : 0
    let kmh = (kmh_raw)

    return (
        <div
            ref={drop}
            style={{
                height: p2,
                width: p1 * 5 + 5 * 4 + 'px',
                fontSize: '14px',
                border: '1px solid rgba(0, 0, 0, 0.8)',
                userSelect: 'none',
                padding: '5px',
                borderRadius: '0px',
                justifyContent: 'center',
                alignItems: 'center',
            }}>{lc.id}{lc.dtr && lc.dtr !== '' ? `::${lc.dtr}` : ''} {(lc.reversed === true || lc.reversed === "true") ? ":" : "."}
            &nbsp;{kmh}km/h&nbsp;{lc.v}&nbsp;
            <span
                onClick={() => {
                    setshowcv(!showcv)
                }}
            ><FiDownloadCloud/></span></div>
    )
}

export default LcDetail